// TODO: add unit tests
export const getCursorFromInputState = ({ isDisabled, isReadOnly, }) => {
    if (isDisabled) {
        return "not-allowed";
    }
    if (isReadOnly) {
        return "auto";
    }
    return "pointer";
};
export const getThumbBackgroundColorFromInputState = ({ isDisabled, isReadOnly, }) => {
    if (isDisabled) {
        return "semantic.icon.disabled";
    }
    if (isReadOnly) {
        return "semantic.icon.secondary";
    }
    return "semantic.surface.1";
};
export const getThumbColorFromInputState = ({ isReadOnly, }) => {
    if (isReadOnly) {
        return "semantic.icon.inverse";
    }
    return "semantic.icon.primary";
};
//# sourceMappingURL=Switch.helpers.js.map